module.exports = __webpack_public_path__ + "img/13Stapelflygbat2.ad965622.png";